import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";   // ✅ Added

const slides = [
  {
    id: 1,
    image: process.env.PUBLIC_URL + "/p1.png",
    title: "Get Approved. Drive Today.",
    subtitle: "Fast, Easy & Flexible Auto Financing for Everyone in Canada",
    buttonText: "Apply Now",
  },
  {
    id: 2,
    image: process.env.PUBLIC_URL + "/p2.png",
    title: "Bad Credit? No Problem.",
    subtitle: "We’re Canada’s #1 in Auto Financing Approval Rates – 95% Success",
    buttonText: "Check Eligibility",
  },
  {
    id: 3,
    image: process.env.PUBLIC_URL + "/p3.png",
    title: "Own Your Dream Car",
    subtitle: "Drive Luxury, Comfort, and Confidence with Our Affordable Financing Plans",
    buttonText: "Start Financing",
  },
  {
    id: 4,
    image: process.env.PUBLIC_URL + "/p4.png",
    title: "Trusted by 1500+ Canadians",
    subtitle: "Low Interest • Quick Approvals • Transparent Process",
    buttonText: "Get Financing",
  },
];

function HeroSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-[90vh] overflow-hidden">
      <AnimatePresence>
        <motion.div
          key={slides[current].image}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${slides[current].image})` }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2 }}
        >
          <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-start px-10 md:px-24">
            
            {/* Title */}
            <motion.h1
              className="text-white text-5xl md:text-6xl font-bold mb-4"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.8 }}
            >
              {slides[current].title}
            </motion.h1>

            {/* Subtitle */}
            <motion.p
              className="text-gray-200 text-xl md:text-2xl mb-6"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.8 }}
            >
              {slides[current].subtitle}
            </motion.p>

            {/* FIXED APPLY NOW BUTTON */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.9, duration: 0.6 }}
            >
              <Link
  to="/apply"
  className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-3 rounded-full text-lg font-medium transition shadow-lg"
>
  Get Financing
</Link>

            </motion.div>

          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default HeroSlider;
